import { getCartId } from "./components/cart/CartAction";
import { getUserId } from "./components/mon-compte/MonCompteAction";
import { getHostApi } from "./utils";
import * as SentryReact from '@sentry/react';
import * as SentryBrowser from '@sentry/browser';

function isClientHttpError(err: any): boolean {
  const status = err?.response?.status ?? err?.status;
  return status === 401 || status === 403;
}

function SentryInitWrapper(Sentry: typeof SentryReact | typeof SentryBrowser, eltId: string) {
  const element = document.getElementById(eltId);
  if (!element) {
    return;
  }

  const sentryDsn = element.dataset.sentryDsn;
  const sentryEnvironment = element.dataset.environment;
  const sentryUse = element.dataset.sentryUse;

  if(sentryDsn && sentryEnvironment && sentryUse) {
    try {
      Sentry.init({
        dsn: sentryDsn,
        environment: sentryEnvironment,
        tunnel: `${getHostApi()}/sentry`,
        debug: sentryEnvironment === 'development',
        integrations: [],
        ignoreErrors: ['AbortError'],
        beforeSend(event, hint) {
          const originalException = hint?.originalException;
          if (isClientHttpError(originalException)) {
            return null;
          }
          return event;
        }
      });  

      const cartId = getCartId();
      if(cartId) {
        Sentry.setContext('cart', {
          id: cartId,
        });
      }

      const userId = getUserId();
      if(userId) {
        Sentry.setUser({
          id: userId,
        });
      }
    } catch(err) {
      console.error('Error initializing Sentry', err);
    }
  }
}

export function initSentryReact(eltId: string): void {
  SentryInitWrapper(SentryReact, eltId);
}

export function initSentryBrowser(eltId: string): void {
  SentryInitWrapper(SentryBrowser, eltId);
}

// Exposer globalement
if (typeof window !== 'undefined') {
  (window as any).initSentryBrowser = initSentryBrowser;
}

export default { initSentryReact, initSentryBrowser };
